class WishlistPage {
  constructor() {
    this.container = document.querySelector("#wishlistGrid");
    this.containerEmpty = document.querySelector("#wishlistEmpty");

    if (!this.container) return;

    this.items = [];

    this.init();
  }

  async init() {
    const wishlistItems = App.wishlist.getItems();


    if (!wishlistItems.length) {
      this.renderEmpty();
      return;
    }

    // Products that were deleted or unpublished come back as null.
    this.items = (
      await Promise.all(wishlistItems.map((item) => this.getProductData(item)))
    ).filter(Boolean);

    if (!this.items.length) {
      this.renderEmpty();
      return;
    }

    this.render();
  }

  async getProductData(item) {
    let product;

    try {
      // The /es/ URL returns Spanish option names and values.
      const response = await fetch(
        VoraxCart.url(`products/${item.handle}.js`),
      );

      if (!response.ok) return null;

      product = await response.json();
    } catch (error) {
      return null;
    }

    const variant = product.variants?.find(
      (variant) => variant.id === item.variantId,
    );

    if (!variant) return null;

    return {
      productId: product.id,
      variantId: item.variantId,
      handle: product.handle,

      title: product.title,

      image: variant.featured_image?.src || product.featured_image,

      price: variant.price,

      options: this.getVariantOptions(product, variant),
    };
  }

  getVariantOptions(product, variant) {
    const options = {};

    product.options.forEach((option, index) => {
      options[option.name] = variant[`option${index + 1}`];
    });

    return options;
  }

  render() {
    this.containerEmpty.hidden = true;
    this.container.innerHTML = "";

    this.items.forEach((item) => {
      const card = this.createCard();

      this.fillCard(card, item);

      this.container.appendChild(card);
    });

    this.bindEvents();
  }

  createCard() {
    const template = document.querySelector("#wishlistCardTemplate");

    return template.content.firstElementChild.cloneNode(true);
  }

  fillCard(card, item) {
    const image = card.querySelector(".wishlist-image");

    image.src = item.image;
    image.alt = item.title;

    const productLink = card.querySelector(".wishlist-link");

    productLink.href = VoraxCart.url(
      `products/${item.handle}?variant=${item.variantId}`,
    );

    card.querySelector(".wishlist-title").textContent = item.title;

    card.querySelector(".wishlist-price").textContent = VoraxCart.formatMoney(item.price);

    const optionsContainer = card.querySelector(".wishlist-options");

    optionsContainer.innerHTML = Object.entries(item.options)
      .map(([key, value]) => {
        return `
        <p>
          ${key}: ${value}
        </p>
      `;
      })
      .join("");

    card.dataset.variantId = item.variantId;
  }

  renderEmpty() {
    // Also clears the last card after it was removed.
    this.container.innerHTML = "";

    // The message is rendered by Liquid in the storefront language.
    this.containerEmpty.hidden = false;
  }

  bindEvents() {
    const removeButtons = this.container.querySelectorAll(".wishlist-remove");

    removeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const variantId = Number(
          button.closest(".wishlist-card").dataset.variantId,
        );

        App.wishlist.remove(variantId);

        this.init();
      });
    });

    const addButtons = this.container.querySelectorAll(".wishlist-add-cart");

    addButtons.forEach((button) => {
      button.addEventListener("click", async () => {
        const variantId = Number(
          button.closest(".wishlist-card").dataset.variantId,
        );

        await this.addToCart(variantId);
      });
    });
  }
  async addToCart(variantId) {
    try {
      const response = await fetch(VoraxCart.url("cart/add.js"), {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error("Error adding product");
      }

      window.location.href = VoraxCart.url("cart");
    } catch (error) {
      console.error(error);
    }
  }
}

new WishlistPage();
